// src/App.js
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
    Outlet
} from 'react-router-dom';

// Zumosoft pages
import Nav from './components/Nav';
import HomePage from './components/Homepage';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Clients from './components/Clients';
import About from './components/About';
import Contact from './components/Contact';
import Five from './components/54321';
import PrivacyPage from './components/Privacy';
import TermsPage from './components/Terms';
import BookingFrame from './components/Bookings';
import ZumoDoVideo from './components/ZumoDoVideo';
import MedExplainCaseStudy from './components/case-studies/MedExAICaseStudy';
import SpicyParks from './components/SpicyParks';

// NeuroNest demo
import DemoApp from './neuronest/DemoApp';

// Global Styles
const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    overflow-x: hidden;
    width: 100%;
    margin: 0;
  }

  html {
    overflow-x: hidden;
  }
`;

// Styled Wrappers
const PageWrapper = styled.div`
  background: linear-gradient(135deg, #6d5bba, #48a9a6);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
  overflow-x: hidden;
  width: 100%;
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  color: white;
  width: 100%;
  min-width: 0;
`;

const HeaderWrapper = styled.header`
  background: #0b0d21;
  padding: 20px;
  width: 100%;
`;

const Footer = styled.footer`
  background: #0b0d21;
  padding: 20px 10px;
  color: white;
  width: 100%;
  margin-top: auto;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  
  a, p {
    margin: 0 10px;
    color: white;
    text-decoration: none;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    a, p { 
      margin: 5px 0; 
    }
  }
`;

// Layout for Zumosoft main site
const MainLayout = () => {
    const currentYear = new Date().getFullYear();

    return (
        <PageWrapper>
            <HeaderWrapper>
                <Nav />
            </HeaderWrapper>

            <Container>
                <Outlet />
            </Container>

            <Footer>
                <FooterLinks>
                    <Link to="/">Home</Link>
                    <Link to="/zumodo">ZumoDO</Link>
                    <Link to="/clients">Our Work</Link>
                    <Link to="/about">About</Link>
                    <Link to="/contact">Contact</Link>
                    <p>&copy; {currentYear} Zumosoft, Inc.</p>
                </FooterLinks>
            </Footer>
        </PageWrapper>
    );
};

// App with separate demo route
function App() {
    return (
        <Router>
            <GlobalStyles />
            <Routes>

             

                {/* NeuroNest demo standalone */}
                <Route path="/neuronest-demo/*" element={<DemoApp />} />

              
                {/* All other Zumosoft routes use MainLayout */}
                <Route path="/*" element={<MainLayout />}>
                    <Route index element={<HomePage />} />
                    <Route path="services" element={<Services />} />
                    <Route path="case-studies" element={<CaseStudies />} />
                    <Route path="clients" element={<Clients />} />
                    <Route path="about" element={<About />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="54321" element={<Five />} />
                    <Route path="terms" element={<TermsPage />} />
                    <Route path="privacy" element={<PrivacyPage />} />
                    <Route path="bookings" element={<BookingFrame />} />
                    <Route path="zumodo" element={<ZumoDoVideo />} />
                    <Route path="only-parks" element={<SpicyParks />} />
                    <Route
                        path="case-studies/medexplain"  
                        element={
                            <MedExplainCaseStudy
                                heroImage="/images/medexplain/SpanishJournal.webp"
                                uiShots={[
                                    "/images/medexplain/Home.webp",
                                    "/images/medexplain/HomeSpanish.webp",
                                    "/images/medexplain/SpanishButton.webp",
                                    "/images/medexplain/Translaton1.webp",
                                    "/images/medexplain/Translation2.webp",
                                    "/images/medexplain/Translation3.webp",
                                ]}
                                uiCaptions={[
                                    "Home Page",
                                    "Home Page in Spanish",
                                    "One-Click translation button",
                                    "Title and search preview translation",
                                    "Search keywords and article translation",
                                    "Questions translation",
                                ]}
                            />
                        }
                    />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;